import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H2, H6 } from "../../../../../AbstractElements";
import { TotalExpendituresTitle } from "../../../../../Constants/Constants";
import { TotalExpendituresChart } from "../../../../../Data/General/Widgets/General";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";

const TotalExpenditures = () => {
  return (
    <Col xl="4" sm="6" className="expenses-card">
      <Card className="earning-card">
        <DashboardCommonHeader title={TotalExpendituresTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="pb-0 px-0">
          <Row>
            <Col xxl="7" xl="12" lg="8" md="7" sm="12" className="box-col-12">
              <div className="expenses-chart" id="Expenses-chart">
                <ReactApexChart type="bar" options={TotalExpendituresChart} series={TotalExpendituresChart.series} height={180} />
              </div>
            </Col>
            <Col xl="5" lg="4" md="5" sm="4" className="earning-content">
              <div className="total-header p-2 pt-0">
                <H2 className="mb-2">{`$ 16,842`}</H2>
                <div className="d-flex">
                  <span className="bg-light-success">
                    <SvgIcon iconId="up-arrow" />
                  </span>
                  <H6 className="font-success">{`+ 40.09%`}</H6>
                </div>
                <span>{`Than last week`}</span>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TotalExpenditures;
